export interface VenueCommit {
  venueId: string
  facilityId: string | null
}

/**
 * Decodes the one value `VenueCellEditor` commits for the Location column.
 *
 * AG Grid commits a single column at a time, and a venue without its surface is
 * an edit this API cannot accept, so the editor packs both halves into one
 * string. Anything that does not carry a venue is not an edit at all — the
 * caller leaves the row alone rather than sending a half-move.
 */
export const decodeVenueCommit = (value: unknown): VenueCommit | null => {
  const [venueId, facilityId] = String(value ?? '').split('|')

  if (!venueId) {
    return null
  }

  return {
    venueId,
    //  An empty half means "no surface chosen", which is a null to send on, not
    //  the empty string — the two are different values to the API.
    facilityId:
      facilityId === '' || facilityId === undefined ? null : facilityId,
  }
}
